import { withFormsy } from 'formsy-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export const checkboxTestId = 'ValidationCheckbox-checkbox';

class ValidationCheckbox extends Component {
  constructor(props) {
    super(props);
    if (props.value) {
      props.setValue(props.value);
    }
    this.state = { isChecked: props.checked };

    // Bind methods
    this.changeValue = this.changeValue.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  changeValue(event) {
    const isChecked = event.currentTarget.checked;
    this.props.setValue(isChecked);
    this.setState({ isChecked });
  }

  onBlur(event) {
    this.props.setValue(event.currentTarget.checked);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked) {
      this.setState({ isChecked: this.props.checked });
    }
  }

  render() {
    const {
      getValue, id, isPristine, showError, showRequired,
    } = this.props;
    const { isChecked } = this.state;

    const errorMessage = this.props.getErrorMessage();
    const invalid = !isPristine() && (showRequired() || showError());
    const isActive = getValue() && getValue().length > 0;
    const errorFieldStyle = { display: invalid ? '' : 'none' };

    return (
      <div className={`ValidationCheckbox form__field form-field ${invalid ? 'form-field--invalid' : ''}`}>
        <div className="field-list checkboxes">
          <div className="ValidationCheckbox__field">
            <input
              checked={isChecked}
              className={`ValidationCheckbox__checkbox required attr_check ${invalid ? 'form-field__error' : ''}`}
              data-test-id={checkboxTestId}
              formNoValidate
              id={id}
              name={this.props.name}
              onBlur={this.onBlur}
              onChange={this.changeValue}
              type="checkbox"
              value={getValue()}
            />
            <div className="ValidationCheckbox__labelContainer">
              <label
                htmlFor={this.props.name}
                className={`ValidationCheckbox__label form-field__label ${isActive ? 'is-active' : ''}`}
              >
                {this.props.title}
              </label>
              <div id={`${id}.errorField`} className="form-field__description" style={errorFieldStyle}>
                <div
                  id={`${id}.errorMessage`}
                  htmlFor={id}
                  className="validation-error form-field__error"
                  style={{ display: 'block' }}
                >
                  {errorMessage}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ValidationCheckbox.propTypes = {
  checked: PropTypes.bool,
  getErrorMessage: PropTypes.func.isRequired,
  getValue: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  isPristine: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  showRequired: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  value: PropTypes.string,
};

ValidationCheckbox.defaultProps = {
  checked: false,
  value: '',
};

export default withFormsy(ValidationCheckbox);
